import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { getExpenseTypes, deleteExpenseType, updateExpenseTypesPagination } from '../../../store/actions/expense_type/expense_type_action';
import { makeStyles, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import TablePagination from '../../ui_components/table_pagination';
import { REACT_ROUTES } from '../../../constants/react_routes';
import history from '../../../services/history';
import ActionsComponent from '../../ui_components/actions_component';

const useStyles = makeStyles((theme) => ({
	paper: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto'
    }
}));

const ExpenseTypesTable = ({ expenseTypes: { collection, totalCount, page, rowsPerPage, filters } }) => {
    const { paper, tableRow } = useStyles();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!collection.length) {
            dispatch(getExpenseTypes({ page, rowsPerPage, filters }));
        }
    }, []);

    const handleClick = (uuid) => {
        history.push(`${REACT_ROUTES.EXPENSE_TYPE}/${uuid}`);
    }

    const handleDeleteExpenseType = (uuid) => {
        dispatch(deleteExpenseType(uuid))
            .then(() => dispatch(getExpenseTypes({ page, rowsPerPage, filters })));
    }

    return (
        <Paper className={paper}>
            <Table aria-label="table">
                <TableHead>
                    <TableRow>
                        <TableCell align="center">Naziv</TableCell>
                        <TableCell align="right">Akcije</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {collection.map(({ uuid, name, deletable }, index) =>
                        <TableRow hover key={index} className={tableRow}>
                            <TableCell align="center">{ name }</TableCell>
                            <TableCell align="right">
                                <ActionsComponent
                                    handleEdit={() => handleClick(uuid)}
                                    handleDelete={() => handleDeleteExpenseType(uuid)}
                                    deletable={deletable}
                                    label="tip troška"
                                />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                <TablePagination
                    page={page}
                    count={totalCount}
                    rowsPerPage={rowsPerPage}
                    filters={filters}
                    updatePagination={updateExpenseTypesPagination}
                 />
            </Table>
        </Paper>
    )
}

ExpenseTypesTable.propTypes = {
    expenseTypes: PropTypes.object
}

const mapStateToProps = (state) => ({
    expenseTypes: state.expenseTypes
});

export default connect(mapStateToProps)(ExpenseTypesTable);
